import { render, staticRenderFns } from "./ActivityLedgerTarget.vue?vue&type=template&id=b672a13e&"
import script from "./ActivityLedgerTarget.vue?vue&type=script&lang=js&"
export * from "./ActivityLedgerTarget.vue?vue&type=script&lang=js&"
import style0 from "./ActivityLedgerTarget.vue?vue&type=style&index=0&id=b672a13e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports